var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVehicleElectric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_818_13993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.416992C26.6504 0.416994 31.8998 0.852452 35.5361 4.47461C39.1788 8.10477 39.583 13.3569 39.583 20.0195C39.583 26.6748 39.1834 31.9222 35.5488 35.5537C31.9152 39.1854 26.6615 39.583 20 39.583C13.3386 39.583 8.08384 39.1854 4.4502 35.5537C0.815495 31.9229 0.416997 26.6749 0.416992 20.0195C0.416992 13.3653 0.815299 8.11876 4.44824 4.48926C8.08304 0.857174 13.3412 0.416992 20 0.416992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.416992C26.6504 0.416994 31.8998 0.852452 35.5361 4.47461C39.1788 8.10477 39.583 13.3569 39.583 20.0195C39.583 26.6748 39.1834 31.9222 35.5488 35.5537C31.9152 39.1854 26.6615 39.583 20 39.583C13.3386 39.583 8.08384 39.1854 4.4502 35.5537C0.815495 31.9229 0.416997 26.6749 0.416992 20.0195C0.416992 13.3653 0.815299 8.11876 4.44824 4.48926C8.08304 0.857174 13.3412 0.416992 20 0.416992Z",
    fill: "url(#paint0_linear_818_13993)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.416992C26.6504 0.416994 31.8998 0.852452 35.5361 4.47461C39.1788 8.10477 39.583 13.3569 39.583 20.0195C39.583 26.6748 39.1834 31.9222 35.5488 35.5537C31.9152 39.1854 26.6615 39.583 20 39.583C13.3386 39.583 8.08384 39.1854 4.4502 35.5537C0.815495 31.9229 0.416997 26.6749 0.416992 20.0195C0.416992 13.3653 0.815299 8.11876 4.44824 4.48926C8.08304 0.857174 13.3412 0.416992 20 0.416992Z",
    stroke: "#F4F4F4",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_818_13993)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.0003,
    cy: 22.222,
    r: 11.1111,
    fill: "#59B16F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_818_13993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.77 23.374L12.5474 23.3291C9.66878 22.7444 7.49951 20.1995 7.49951 17.1465V13.8076C7.49953 13.4863 7.75636 13.2296 8.07764 13.2295H9.99365V8.77246C9.9938 8.21056 10.4748 7.76557 11.0474 7.81836V7.81738C11.5364 7.86545 11.9116 8.30629 11.9116 8.8252V13.2295H15.7231V8.77246C15.7233 8.20869 16.2049 7.76103 16.7739 7.81738H16.7749C17.2588 7.86472 17.6353 8.30518 17.6353 8.8252V13.2295H19.5464C19.8676 13.2297 20.1235 13.4864 20.1235 13.8076V17.1465C20.1235 20.1995 17.9552 22.7444 15.0767 23.3291L14.854 23.374V26.5439C14.8541 28.6599 16.7098 30.3574 18.8813 30.0859C20.7044 29.8581 21.9888 28.2291 21.9946 26.4199C22.0095 23.3376 24.5103 20.8418 27.5972 20.8418H31.4634C32.0349 20.8421 32.4993 21.3074 32.4995 21.8789C32.4995 22.4496 32.0353 22.9177 31.4556 22.9219H27.6382C25.6696 22.922 24.069 24.5168 24.0688 26.4912V26.5381C24.0688 29.7253 21.4127 32.302 18.1997 32.1826C15.1494 32.0685 12.7701 29.4611 12.77 26.3926V23.374Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "url(#paint1_linear_818_13993)",
    strokeWidth: 0.555556
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_818_13993",
    x: -2.22195,
    y: -0.000271797,
    width: 44.4444,
    height: 44.4444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.55556,
    result: "effect1_foregroundBlur_818_13993"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_818_13993",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#59B16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB42C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_818_13993",
    x1: 11.3251,
    y1: 9.81337,
    x2: 28.1346,
    y2: 32.3471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_818_13993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_818_13993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5556,
    height: 25.5556,
    fill: "white",
    transform: "translate(7.22217 7.22217)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicleElectric);
export default __webpack_public_path__ + "static/media/icon_vehicle_electric.40b384fb1de35d5929d3fe547992655d.svg";
export { ForwardRef as ReactComponent };